// extracted by mini-css-extract-plugin
module.exports = {"label":"ToggleSwitch_label__2K20U","active":"ToggleSwitch_active__3GzsH","switch":"ToggleSwitch_switch__3Qxne","disabled":"ToggleSwitch_disabled__36zui"};